export default __webpack_public_path__ + "static/media/1kw-fiber-laser.c0501b85.png";